import React from 'react';
import ModularAppView from './ModularAppView';

export default function SshKeysApp() {
  return (
    <ModularAppView
      slug="ssh-keys"
      defaultTitle="SSH Keys"
      defaultIcon="Terminal"
      defaultCategory="Developer"
    />
  );
}
